import { useContext } from 'react';
import { EditorConfigButtons } from 'components/Editors/EditorConfigButtons';
import { EditorConfigButton } from 'components/Editors/EditorConfigButton';
import { PropertyEditorContext } from 'components/property-editors/contexts/PropertyEditorContext';
import { ContextProviderNode } from '@decisions/server/DecisionsFramework/Design/Properties';
import { ListMappingItem } from './ListMappingItem';
import { getBuildJoinArraysMappingValue } from './utils/MappingSelectorUtils';

interface IListMappingSelectorProps {
  child: ContextProviderNode;
  path: string[];
  fieldPath: string[];
  mapping: string;
}

/**
 * A set of list mappings, e.g. items of a 'build array' mapping.
 *
 * TODO someday, it would be great to allow drag/drop reorder of these. No way to reorder them now.
 *
 * Copyright (c) 2020 Decisions All Rights Reserved
 */
export function ListMappingSelector({ child, path, fieldPath, mapping }: IListMappingSelectorProps) {
  const { onChange } = useContext(PropertyEditorContext);
  return (
    <>
      <EditorConfigButtons>
        <EditorConfigButton onClick={() => onChange(getBuildJoinArraysMappingValue(mapping), fieldPath)}>
          Add
        </EditorConfigButton>
      </EditorConfigButtons>
      <section className="dpc-mapping-selector__nested-mapping">
        {child.Children?.map((arrayMappingNode, i) => {
          const nestedPath = [...path, arrayMappingNode.Node.Name];
          return (
            /* skipping item 0, because it's the parent mapping node */
            i > 0 && (
              <ListMappingItem key={nestedPath.join(',')} node={arrayMappingNode} path={path} onChange={onChange} />
            )
          );
        })}
      </section>
    </>
  );
}
